import { render, staticRenderFns } from "./EmptyInfo.vue?vue&type=template&id=23693aba&"
import script from "./EmptyInfo.vue?vue&type=script&lang=js&"
export * from "./EmptyInfo.vue?vue&type=script&lang=js&"
import style0 from "./EmptyInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23693aba')) {
      api.createRecord('23693aba', component.options)
    } else {
      api.reload('23693aba', component.options)
    }
    module.hot.accept("./EmptyInfo.vue?vue&type=template&id=23693aba&", function () {
      api.rerender('23693aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/partials/EmptyInfo.vue"
export default component.exports